package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.PatchVenueRequest

data class PatchVenueDraftCommand(
    val venueId: String,
    val request: PatchVenueRequest
)
